export default "__VITE_ASSET__BxYh0_8z__"